/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {
    Button,
    Text,
    Flex,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {
    ADD_FILTER,
    REMOVE_FILTER
} from '@salesforce/retail-react-app/app/pages/product-list/partials/refinements-utils'

const SizeRefinements = ({filter, toggleFilter, selectedFilters}) => {
    const {formatMessage} = useIntl()
    const styles = useMultiStyleConfig('FilterSwatches', {
        variant: 'square',
        disabled: false
    })

    return (
        <Flex
            className={'sizeRefinements'}
            flexWrap={'wrap-reverse'}
            flexDirection={'row-reverse'}
            justifyContent={'flex-end'}
            gap={'10px'}
        >
            {filter.values?.map((value, idx) => {
                // Note the loose comparison, for "string == number" checks.
                const isSelected = selectedFilters.some((filterValue) => filterValue == value.value)
                // Don't display refinements with no results, unless we got there by selecting too
                // many refinements
                if (value.hitCount === 0 && !isSelected) return

                return (
                    <Button
                        key={idx}
                        {...styles.swatch}
                        backgroundColor={isSelected ? 'black' : ''}
                        color={isSelected ? 'white' : 'gray.900'}
                        onClick={() => toggleFilter(value, filter.attributeId, isSelected)}
                        aria-checked={isSelected}
                        variant="none"
                        marginBottom={0}
                        marginRight={0}
                        aria-label={formatMessage(isSelected ? REMOVE_FILTER : ADD_FILTER, value)}
                    >
                        <Text
                            as={'span'}
                            {...styles.swatchButton}
                            fontSize={'md'}
                            fontWeight={'medium'}
                        >
                            {value.label}
                        </Text>
                    </Button>
                )
            })}
        </Flex>
    )
}

SizeRefinements.propTypes = {
    filter: PropTypes.object,
    selectedFilters: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
    toggleFilter: PropTypes.func
}

export default SizeRefinements
